//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DetailEleServerDisk.ts						</Name>
//    <Description> Dialog detailu licence										</Description>
//    <Author>      FFIALA													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-11-07                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=482.70.X1
//AdtGeneratorConfig:[ T:(wflsdis) V1:(server_name,disk_name,poznamka,typ_media,vel_max,vel_free,vel_min,files_max,dir_vel_max,dir_vel_min,priorita,dat_zmena,disk_name_wo,disk_name_fyz,typ_db,db_name,servername32,dat_od,dat_do) V2:(aktivita,zmenu_prov) K1:(f_wflsdis_ixs_ulz,f_wflsdis_priz_ro,f_wflsdis_ser,f_wflsdis_typ_zip) K2:() ]



namespace Gordic.Adm.WebControls {


    /** inteface - Response slu�eb pro Detail */
    export interface IDetailEleServerDiskResponse {
        /** data v�stupu */
        data: Gordic.AdmIsl.Interface.GEleServerDiskDto,

        result: {
            /** data v�stupu */
            data: Gordic.AdmIsl.Interface.GEleServerDiskDto,
            /** chyby */
            errors: {
                /** zpr�va chyby */
                message: string
            }[],
            /** typ v�stupu operace */
            kind: Adm.Utils.GOperationResultKind
        }
    }

	//#endregion
    const { gcontent } = Decorators;

    /** dialog detailu */
    @gcontent
    export class DetailEleServerDisk extends GContentBase<DetailBase> {

        //#region attributes

        ///** p��znak, �e se jedn� o nov� z�znam */
        //private newRecord: boolean;
        ///** P��znak, �e okno se nach�z� v edita�n�m re�imu */
        //private editMode: boolean;

        /** PK - server_name */
        private server_name: string | null | undefined;
        /** PK - disk_name */
        private disk_name: string | null | undefined;
        
        /** data detailu */
        private data: Gordic.AdmIsl.Interface.GEleServerDiskDto;
		///*** element panelu v sidebaru */
		//private panelElement: JQuery<HTMLElement>
		//private panelId: string;
		///** elmenet sidebaru */
		//private sidebar: JQuery<HTMLElement>;
		/** p��znak p��m�ho p��stupu na detail */
		private detailCommand: boolean

		//#endregion

		//#endregion


        /** onContentReady */
        public onContentReady() {
            this.init();
        }
		//#region ready & init

        public closing() {
            var dfd = $.Deferred();
            return;
        }

        /** refreshDetail content */
        private refreshDetail(): void {

            this.HideAllFlash(); 
			this.load();
		}

        /** Na�ten� dat ze serveru na n�sledn� nastaven� na detail okn� */
        private loadData() {

            this.HideAllFlash(); 

            var fragments: string[] = [Utils.GAdmIslConst.detail];

            if (this.newRecord) {
                fragments.push(Utils.GAdmIslConst.defaultValuesForNewRecord);
            }

            var readResult: any = this.isl.EleServerDisk.read({
                data: { server_name: this.server_name, disk_name: this.disk_name },
                fragments: fragments
            } ).get();

            // SUCCESS
            readResult.done((output: IDetailEleServerDiskResponse) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {

                    this.data = output.data;
                    this.server_name = output.data.server_name;
                    this.disk_name = output.data.disk_name;

                    this.element.findFields().gfield("model", "apply", this.data);
                    if (this.newRecord) 
                        this.setEditMode(true);       // p�i NEW je okno ihned p�epnuto do edit re�imu - mus� b�t p�ed setMenuButtons()

                    this.setMenuButtons(this.editMode);
                    this.createSidebar();
                    //this.createGTab();
                } else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowLoadError(error.message, index);
                    }
                }
            });
            // ERROR
            readResult.fail((err) => {
                console.error("Chyba na�ten�! " + err );
                this.ShowLoadError("jres:32131045!");
            });   
        } // loadData

		//#endregion

        /** Ulo�en� dat formul��e do datab�ze */
        private saveData(nova_data: Gordic.AdmIsl.Interface.GEleServerDiskDto): void {

            this.HideAllFlash(); 

            var upsertResult: any = this.isl.EleServerDisk.upsert({ data: nova_data }).get();

            upsertResult.done((output: IDetailEleServerDiskResponse) => {

                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    DetailBase.ClearAllCache(this);
                    this.data = output.data; // prevezmu nova data vznikla ulozenim
                    this.server_name = output.data.server_name;
                    this.disk_name = output.data.disk_name;

                    this.element.findFields().gfield("model", "apply", this.data);  // nasetov�n� nov�ch dat do detailu
                    this.ShowSaveSuccess();     // flash �sp�n�ho ulo�en�
                    this.createSidebar();
                    this.setEditMode(false);
                    this.setMenuButtons(false);
                }
                else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowSaveError(error.message, index);           // flash ne�sp�n�ho ulo�en�
                    }
                }

            });

            upsertResult.fail((err) => {
                console.error("Chyba ulo�en�! ");    
                this.ShowSaveError("jres:32000125!");   //RC 32000125 : Chyba ulo�en�
            });            
        }

		/** init content */
		private init() {

			// lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				var GinListControlsObject = (Gin.DetailBuilderComponents as any).GinListControls.create(this);
				this.actions.addRange(GinListControlsObject.actions);
				this.createStatusBar(GinListControlsObject.statusBar);
				$.extend(this, GinListControlsObject.contentExtensions);
			}

			this.setTitle();
			this.createMenuBar();
			this.createForm();
			this.createCommandBar();

            // lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				// vytvo�it �ipky na proch�zen� detailu
                (this as any).listControls_setup({
                    //gridRemoteControl: this.gridRemoteControl,
					//funkce, kter� ��dek z gridu p�etransformuje v dto pro zavol�n� this.load(dto); M��e vracet promise.
					rowToDto: function (gridState) {
						return {
                            server_name: gridState.currentRow.data.server_name,
                            disk_name: gridState.currentRow.data.disk_name,
						};
					},
					//template pro tooltip na �ipce n�sleduj�c�
                    nextItemTemplate: "jres:33000155",
					//template pro tooltip na �ipce p�edchoz�
                    prevItemTemplate: "jres:33000156"
				});
				(this as any).listControls_updateCaptions();
            }
		}

		/** vytvo�it statusbar */
		private createStatusBar(GinListControlsObject?: any) {
			const bar: MenuParams[] = [];
			if (GinListControlsObject !== undefined) {
				bar.push.apply(bar, GinListControlsObject);
			}
			this.statusBar(bar);
		}

		//#endregion

		//#region data

        /** Skryt� v�ech flash */
        private HideAllFlash() {
            // skryji p��padn� Flash panely - mus�m za��t s �ist�m �t�tem
            this.hideFlash("idSaveSuccess");    
            this.hideFlash("idSaveError");  
            this.hideFlash("idLoadError");
            for (var index = 0; index < 10; index++) {
                this.hideFlash("idSaveError" + index);
                this.hideFlash("idLoadError" + index);
            }
        }
        /** Zobraz� p��znaku �sp�n�ho ulo�en� */
        private ShowSaveSuccess() {
            this.showFlash("jres:32000123", "g-state-success", 2000, "idSaveSuccess"); //RC 32000123 : Detail byl �sp�n� ulo�en
        }
        /** Zobraz� p��znaku chyby p�i ulo�en� dat */
        private ShowSaveError(text: string, index?: number) {
            if (index === undefined)
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idSaveError" ); //RC 32000124 : Chyba
            else
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idSaveError" + index); //RC 32000124 : Chyba
        }
        /** Zobraz� p��znaku chyby p�i na�ten� dat */
        private ShowLoadError(text: string, index?: number) {
            if (index === undefined)
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idLoadError"); //RC 32000124 : Chyba
            else
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idLoadError" + index); //RC 32000124 : Chyba
        }

        

		//#region title

		/** nastavit titulek dialogu */
		private setTitle() {

            var title = "";

            if (this.newRecord === false) {
                title = "jres:32131033"  	//RC 32131033 : Detail
            }
            else {
                title = "jres:32000121" //RC 32000121 : Nov� z�znam
            }
            this.title = title;

		}


		//#endregion

		//#region form

		/** vytvo�it formul�� a na�ten� dat ze serveru */
        private createForm() {

            var form = $("<div>").appendTo(this.element);

            var Form = new Gordic.Forms.Form({							// odstranit any, az bude .d.ts k filefield policku
                name: "FormEleServerDiskService",
                layoutDescriptor: "L2M2S1, L-2-6-4, M-4-8-0, S-12-12-0",
            });

            Form
                .addSection("jres:29809466") //RC 29809466 : Disk elektronick�ho �lo�i�t�

                .addRow({
                    label: "jres:30028705" //RC 30028705 : Jm�no serveru elektronick�ho �lo�i�t�
                })
                .addField("gstringbox", {
                    name: "server_name",
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    disabled: !this.newRecord,
                })

                .addRow({
                    label: "jres:30027711" //RC 30027711 : Jm�no disku elektronick�ho �lo�i�t�
                })
                .addField("gstringbox", {
                    name: "disk_name",
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    disabled: !this.newRecord,
                })

                .addRow({
                    label: "jres:30027712" //RC 30027712 : Fyzick� jm�no disku
                })
                .addField("gstringbox", {
                    name: "disk_name_fyz",
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    disabled: !this.newRecord,
                })

                .addRow({
                    label: "jres:30027716" //RC 30027716 : Skupina �lo�i��
                })
                .addField("gselectbox", Gordic.Prefabs.Select.wflsulz(), {
                    dropdown: true,
                    name: "ixs_ulz",                                           // n�zev polo�ky
                    model: "model.ixs_ulz=value.ixs_ulz",                               // model je to, co je na teto strance , value je to, co je v pol��ku
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    disabled: !this.newRecord
                })

                .addRow({
                    label: "jres:30027718" //RC 30027718 : Priorita disku
                })
                .addField("gnumberbox", {
                    disabled: !this.newRecord,
                    name: "priorita",
                    customClass: "w-4",
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    emptyValue: null
                }) 

                .addRow({
                    label: "jres:30027719" //RC 30027719 : Pouze pro �ten�
                })
                .addField("gselectbox", Gordic.Prefabs.Select.wflcpro(), {
                    dropdown: true,
                    name: "priz_ro",                                           // n�zev polo�ky
                    model: "model.priz_ro=value.priz_ro",                               // model je to, co je na teto strance , value je to, co je v pol��ku
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    disabled: !this.newRecord
                })

                .addRow({
                    label: "jres:30027725" //RC 30027725 : Zp�sob ulo�en�
                })
                .addField("gselectbox", Gordic.Prefabs.Select.wflczip(), {
                    dropdown: true,
                    name: "typ_zip",                                           // n�zev polo�ky
                    model: "model.typ_zip=value.typ_zip",                               // model je to, co je na teto strance , value je to, co je v pol��ku
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    disabled: !this.newRecord
                })

                .addRow({
                    label: "jres:29930689" //RC 29930689 : Pozn�mka
                })
                .addField("gstringbox", {
                    name: "poznamka",
                    disabled: !this.newRecord,
                })

                // nepou��v� se
                //.addRow({
                //    label: "jres:30027724" //RC 30027724 : Typ m�dia
                //})
                //.addField("gnumberbox", {
                //    disabled: !this.newRecord,
                //    name: "typ_media",
                //    customClass: "w-4",
                //    emptyValue: null
                //}) 

                .addRow({
                    label: "jres:30027727" //RC 30027727 : V�choz� velikost disku
                })
                .addField("gnumberbox", {
                    disabled: !this.newRecord,
                    name: "vel_max",
                    customClass: "w-4",
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    emptyValue: null
                }) 

                .addRow({
                    label: "jres:30027726" //RC 30027726 : Velikost voln�
                })
                .addField("gnumberbox", {
                    disabled: !this.newRecord,
                    name: "vel_free",
                    customClass: "w-4",
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    emptyValue: null
                }) 

                .addRow({
                    label: "jres:30027728" //RC 30027728 : Velikost minim�ln�
                })
                .addField("gnumberbox", {
                    disabled: !this.newRecord,
                    name: "vel_min",
                    customClass: "w-4",
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    emptyValue: null
                }) 

                .addRow({
                    label: "jres:30027714" //RC 30027714 : Maxim�ln� po�et soubor�
                })
                .addField("gnumberbox", {
                    disabled: !this.newRecord,
                    name: "files_max",
                    customClass: "w-4",
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    emptyValue: null
                }) 

                .addRow({
                    label: "jres:30027709" //RC 30027709 : Maxim�ln� velikost adres��e
                })
                .addField("gnumberbox", {
                    disabled: !this.newRecord,
                    name: "dir_vel_max",
                    customClass: "w-4",
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    emptyValue: null
                }) 

                .addRow({
                    label: "jres:30027710" //RC 30027710 : Minim�ln� voln� m�sto v adres��i
                })
                .addField("gnumberbox", {
                    disabled: !this.newRecord,
                    name: "dir_vel_min",
                    customClass: "w-4",
                    validators: [new Gordic.Validators.Required()],                                 // valid�tor - pole mus� b�t vypln�n�
                    emptyValue: null
                }) 

                .addRow({
                    label: "jres:29930672" //RC 29930672 : Platnost OD
                })
                .addField("gdatebox", {
                    disabled: !this.newRecord,
                    name: "dat_od",
                    valueType: "datetime"
                })

                .addRow({
                    label: "jres:29930670" //RC 29930670 : Platnost DO
                })
                .addField("gdatebox", {
                    disabled: !this.newRecord,
                    name: "dat_do",
                    valueType: "datetime"
                }) 

                .addRow({
                    label: "jres:29928893" //RC 29928893 : Typ DB stroje
                })
                .addField("gstringbox", {
                    name: "typ_db",
                    disabled: !this.newRecord,
                })

                .addRow({
                    label: "jres:29928817" //RC 29928817 : Jm�no datab�ze
                })
                .addField("gstringbox", {
                    name: "db_name",
                    disabled: !this.newRecord,
                })

                .addRow({
                    label: "jres:30027722" //RC 30027722 : Jm�no DB serveru
                })
                .addField("gstringbox", {
                    name: "servername32",
                    disabled: !this.newRecord,
                })

                .addRow({
                    label: "jres:32131032" //RC 32131032 : Zm�n�no
                })
                .addField("gdatebox", {
                    disabled: true,
                    name: "dat_zmena",
                    valueType: "datetime"
                }) 

                .addRow({
                    label: "jres:32131031" //RC 32131031 : Zm�nil
                })
                .addField("gselectbox", Gordic.Prefabs.Select.ginszmp(), {
                    disabled: true,
                    dropdown: true,                                                                 // pol��ko jako combobox
                    name: "zmenu_prov",                                                            // n�zev polo�ky
                    model: "model.zmenu_prov=value.ixs_zmp"                                       // model je to, co je na teto strance , value je to, co je v pol��ku
                })  

                // asi se nepou��v�
                //.addRow({
                //    label: "jres:30027713" //RC 30027713 : Fyzick� jm�no disku pro tenk� aplikace
                //})
                //.addField("gstringbox", {
                //    name: "disk_name_wo",
                //    disabled: !this.newRecord,
                //})



                // reader nen� pot�eba, je to tam jako string
                //.addRow({
                //    label: "jres:30028705" //RC 30028705 : Jm�no serveru elektronick�ho �lo�i�t�
                //})
                //.addField("gselectbox", Gordic.Prefabs.Select.wflsser(), {
                //    dropdown: true,
                //    name: "server_name",                                           // n�zev polo�ky
                //    model: "model.server_name=value.server_name",                               // model je to, co je na teto strance , value je to, co je v pol��ku
                //    disabled: !this.newRecord
                //})

            form.gform("createFrom", Form);
            Gordic.Utils.Form.markRequired(form);       // rozsv�t� modr� obdeln�ky u erquired pol�

            this.loadData();            // ze serveru se na�tou data a to i pro p��pad this.newRecord - v tom p��pad� se �tou aspo� default value a permissions

            // Vytvo�en� funkce pro p�echod na edita�n� re�im v r�mci dvojkliku na libovoln�m pol��ku formul��e
            form.findFields().dblclick(() => {
                if (this.newRecord === false && Utils.getCanEdit(this.data.Permissions)) {
                    this.setEditMode(true);
                    this.setMenuButtons(true);
                }
            });


		}

		//#endregion

		//#region menubar

		/** vytvo�it menubar */
		private createMenuBar() {

			const menuBar: MenuParams[] = [];

            // SAVE
            menuBar.push({
                favorite: true,
                action: this.actions.add(new GAction({
                    visible: this.newRecord,
                    name: "actSaveRecord",
                    icon: "gi-save",
                    caption: "jres:32131041",			//RC 32131041 : Ulo�it
                    run: () => {
                        Adm.Utils.waitForValues(this.element)
                            .then((validateIsOk) => {
                                if (validateIsOk === true) {
                                    // kolekce dat
                                    var nova_data: Gordic.AdmIsl.Interface.GEleServerDiskDto = {};       // vytvo��m pr�zdn� objekt spr�vn�ho typu
                                    this.findFields().gfield("model", "collect", nova_data);    // na�tu do n�j data z formul��e
                                    this.saveData(nova_data);                                   // pokus�m se ulo�it data do DB
                                }
                            })
                    }
                }))
            });

            if (this.newRecord === false) {
                // EDIT
                menuBar.push({
                    favorite: true,
                    action: this.actions.add(new GAction({
                        visible: true,
                        name: "actEditRecord",
                        icon: "gi-pencil",
                        caption: "jres:32000120",			//RC 32000120 : Editace
                        run: () => {
                            this.setEditMode(true);
                            this.setMenuButtons(true);
                        }
                    }))
                });
                // CANCEL EDIT
                menuBar.push({
                    favorite: true,
                    action: this.actions.add(new GAction({
                        visible: false,
                        name: "actCancelSaveRecord",
                        icon: "gi-window-close",
                        caption: "jres:32000122",			//RC 32000122 : Ukon�it editaci
                        run: () => {
                            this.refreshDetail();           // ob�erstv�m p�vodn� data z datab�ze
                            this.HideAllFlash();
                            this.setEditMode(false);
                            this.setMenuButtons(false);
                        }
                    }))
                });
            }

            // REFRESH
			menuBar.push({
				align: "opposite",
				favorite: true,
				action: this.actions.add(new GAction({
					icon: "gi-refresh",
					name: "actRefresh",
					caption: "jres:32131040",			//RC 32131040 : Ob�erstven�
					run: () => {
						this.refreshDetail();
					}
				}))
			});

			this.menuBar(menuBar);

        }

        /** P�epnut� dostupnosti pol��ek podle aktu�ln�ho re�imu okna 
         editMode - p��znak, �e okno je v edita�n�m re�imu
         */
        private setEditMode(editMode: boolean) {

            // odblokov�n�/zablokov�n� v�ech pol��ek formul��e
            this.findFields().gfield("option", { disabled: !editMode });

            // PK read only
            this.findFields("server_name").gfield("option", { disabled: true });

            if (!this.newRecord)    // nasleduj�c� pol��ka jsou p��stupn� pouze p�i zakl�d�n� z�znamu
            {
                this.findFields("disk_name").gfield("option", { disabled: true });
            }

            // specifick�
            this.findFields("typ_db").gfield("option", { disabled: true });
            this.findFields("db_name").gfield("option", { disabled: true });
            this.findFields("servername32").gfield("option", { disabled: true });

            // v�dy read only
            this.findFields("dat_zmena").gfield("option", { disabled: true });
            this.findFields("zmenu_prov").gfield("option", { disabled: true });

            this.editMode = editMode;
        }

        /** P�epnut� viditelnost tla��tek podle aktu�ln�ho re�imu okna 
         editMode - p��znak, �e okno je v edita�n�m re�imu
         */
        private setMenuButtons(editMode: boolean) {
            Utils.setActionVisible(this.actions.actEditRecord, !editMode);
            Utils.setActionEnabled(this.actions.actEditRecord, Utils.getCanEdit(this.data.Permissions));

            Utils.setActionVisible(this.actions.actSaveRecord, editMode);
            Utils.setActionVisible(this.actions.actCancelSaveRecord, editMode);
        }


		//#endregion

		//#region commandbar

		/** vytvo�it commandbar */
		private createCommandBar() {

			const commandBar: MenuParams[] = [];

            // CLOSE
			commandBar.push({								
				favorite: true,
				action: this.actions.add(new GAction({
					name: "actZavrit",
					icon: "gi-window-close",
					caption: "jres:32131042",				//RC 32131042 : Zav��t
					run: () => {
						this.close();
					}
				}))
			});

			this.commandBar(commandBar);
		}

		//#endregion

		//#region statusbar

		/** odstranit v�echny vlastn� t��dy ze statusbaru */
		private removeAllCustomClassOnStatusBar() {
			var myclass = $(".statusbar-aktivita-class").find(".g-static__text");
			myclass.removeClass("statusbar-aktivita-class-green");
			myclass.removeClass("statusbar-aktivita-class-blue");
			myclass.removeClass("statusbar-aktivita-class-red");
		}

		//#endregion

		//#region sidebar

		/** vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {

			this.panelId = "panelNahled";

			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
                leaf: "jres:32131038",								//RC 32131038 : N�hled
                icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel(ITypePanel.Neurceno, $(ev.target))
				},
			} as GSideBarPanelOptions;

			return panel;
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/** vytvo�it sidebar */
		private createSidebar() {

			this.removeSidebar();
			var panel = this.createPanel();

			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: [panel]
				}
			});
		}

		/** ob�erstven� panelu v sidebaru */
		private refreshPanel(type: ITypePanel, elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}

			if (panel !== undefined) {

				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}

				this.panelElement = $("<div>").appendTo(panel);

				//if (type === ITypePanel.HistorieSpusteni) {
				//	GridUtils.setPanelGrid("jres:32000055", this.row_historie_spusteni, this.gridFormatHistorieSpusteni, this.panelElement);
				//}
				//else {
					this.setPreviewEmpty();
				//}

			}

		}
        /** vytov�en� pr�zdn�ho sidebar panelu s n�hledek */
		private setPreviewEmpty(): void {
			var p7s_element = $("<div'>").addClass("Adm-p7s-class");
			p7s_element.appendTo(this.panelElement);
			p7s_element.text("jres:32131043"); //RC 32131043 : N�hled nen� k dispozici.
		}

		//#endregion


	}
}
